import { createApi} from "@reduxjs/toolkit/query/react";
import customBaseQuery from "./base.api.ts";

interface Client {
  client_id: number;
  client_username: string;
}

interface ClientResponse {
  clients: Client[];
}

export const clientApi = createApi({
  reducerPath: "clientApi",
  baseQuery: customBaseQuery, 
  tagTypes: ['Client'],
  endpoints: (builder) => ({
    getClientsByCompany: builder.query<Client[], number>({
      query: (company_id) => ({
        url: `/gw/clients/company/${company_id}`,
        method: "get",
      }),
      transformResponse: (response: ClientResponse) => {
        return response.clients.map((client: Client) => ({
          client_id: client.client_id,
          client_username: client.client_username
        }));
      },
      providesTags: ['Client'],
    }),
  }),
});

export const { 
  useGetClientsByCompanyQuery 
} = clientApi;